export const IOS_INSTALL_URL =
  'https://apps.apple.com/us/app/nantahala-mountain-resort/id6778447491';

/** Google Play internal testing opt-in URL (Play Console → Internal testing → Testers). */
export const ANDROID_INSTALL_URL = process.env.REACT_APP_ANDROID_INSTALL_URL || '';

export async function fetchInstallLinks() {
  try {
    const response = await fetch('/install-links.json', { cache: 'no-store' });
    if (!response.ok) return { ios: IOS_INSTALL_URL, android: ANDROID_INSTALL_URL };
    const data = await response.json();
    return {
      ios: data.ios || IOS_INSTALL_URL,
      android: data.android || ANDROID_INSTALL_URL,
    };
  } catch {
    return { ios: IOS_INSTALL_URL, android: ANDROID_INSTALL_URL };
  }
}